import React from "react";

import { WHATSAPP_URL } from "../lib/constants";
import WhatsAppIcon from "./WhatsAppIcon";

export default function WhatsAppFab() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp com a Viagens Orion"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 z-40 group whatsapp-fab h-16 w-16 max-md:bottom-[76px]"
    >
      {/* Outer soft glow */}
      <span
        className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 blur-2xl group-hover:opacity-90 transition-opacity"
        aria-hidden
      />
      {/* Pulsating ring */}
      <span
        className="absolute inset-0 rounded-full border-2 border-[#25D366]/70 animate-ping"
        aria-hidden
      />

      {/* Icon plate */}
      <span className="relative flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-[#25D366] via-[#1ebe57] to-[#128C7E] shadow-[0_16px_38px_rgba(37,211,102,0.5)] group-hover:scale-110 transition-transform duration-300 overflow-hidden">
        {/* Shine sweep */}
        <span className="whatsapp-fab-shine" aria-hidden />
        {/* Inner highlight */}
        <span
          className="absolute -top-3 -left-3 h-10 w-10 rounded-full bg-white/30 blur-md"
          aria-hidden
        />
        <WhatsAppIcon size={34} color="#ffffff" className="relative drop-shadow-[0_2px_6px_rgba(0,0,0,0.35)]" />
      </span>

      {/* Red notification dot */}
      <span
        className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-red-500 border-2 border-white flex items-center justify-center text-[10px] font-bold text-white shadow-md animate-pulse"
        aria-hidden
      >
        1
      </span>
    </a>
  );
}
